import React from 'react';

export default () => <h1>NotFound</h1>



// WEBPACK FOOTER //
// ./src/components/pages/NotFound.js